<template>
    <div class="communication-hub">
        <v-snackbars :objects.sync="communications">

            <template v-slot:default="{ message, id, index, icon }">             
                <v-layout align-center>
                    <v-icon class="pr-3" dark large>{{communications[index].icon}}</v-icon>
                    <v-layout column>
                        <div>
                            <span v-html="message"></span>
                        </div>
                    </v-layout>
                   
                </v-layout>
            </template>

            <template v-slot:action="{ close }">
                <v-btn icon @click="close()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>

        </v-snackbars>
    </div>
</template>
<script>
    import { UrlBundles, UserInfo, EventHub } from "Libs/core";
    import VSnackbars from "v-snackbars"

    export default {
        data() {
            return {
                urlBundles: UrlBundles,
                userInfo: UserInfo,
                eventHub: EventHub,
                communications: [],
            };
        },
        mounted() {
            this.$nextTick(() => {
                this.eventHub.$on("communication", (data) => {
                    const { bottom, duration, left, msg, right, top, color, customFunction, textClick, icon } = data;

                    let communication = {
                        message: msg || "",
                        top: top || false,
                        bottom: bottom || false,
                        left: left || false,
                        right: right || false,
                        color: color || null,
                        transition: "fab-transition",//, "scale-transition", "fade-transition"  fab-transition
                        timeout: duration || 15000,
                        icon: icon || null,
                    };

                    this.communications.push(communication);
                });              
            });
        },
        methods: {

        },
        components: {
            "v-snackbars": VSnackbars
        },
    };
</script>

<style lang="scss">
    .v-snack:not(.v-snack--absolute) {
        height: 100%;
    }

    .communication-hub .v-snack__wrapper{
        width: 100% !important;
        min-width: none !important;
    }

</style>